// @packages
import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';

// @styles
import styles from './styles';

const CtrlTabPanel = ({
    classes: { box },
    children,
    value,
    index
}) => (
    <div
        role="tabpanel"
        hidden={value !== index}
    >
        <Box p={3} className={box} style={{ display: value === index ? 'block' : 'none' }}>
            {children}
        </Box>
    </div>
);

CtrlTabPanel.propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.element,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};

CtrlTabPanel.defaultProps = {
    children: <></>
};

export default withStyles(styles)(CtrlTabPanel);
